import React, {Component} from "react";
import {injectIntl} from "react-intl";
import {connect} from "react-redux";
import IdentityDocuments from "./IdentityDocuments";
import IdentityData from "./IdentityData";
import Constants from "../../../services/Constants";

class Identity extends Component {

  componentDidMount(){
    const {uuid} = this.props;
    if (uuid) {
      this.props.dispatchFetchJourneyIdentityData({uuid});
      this.props.dispatchFetchJourneyIdentityDocuments({uuid});
    }
  }

  handleDeletePhoto = (params) => {
    const {uuid, key} = params;
    this.props.dispatchDeleteJourneyIdentityDocuments({uuid, key});
  }

  render() {
    return (
      <React.Fragment>
        <IdentityDocuments onDeletePhoto={this.handleDeletePhoto} {...this.props}/>
        <IdentityData{...this.props}/>
      </React.Fragment>
    )
  }
}

const mapStateToProps = state => {
  const intervention = state.fetchIntervention.intervention || {};
  const canWrite = intervention.status !== Constants.STATUS_ARCHIVED.value;
  return {
    identity : intervention.identityData,
    identityDocuments : intervention.identityDocuments,
    canWrite
  }};


const mapDispatchToProps = dispatch => ({
  dispatchFetchJourneyIdentityData: (params) => dispatch({type: 'FETCH.JOURNEY_IDENTITY_DATA.REQUEST', ...params}),
  dispatchSaveJourneyIdentityDocuments: (params) => dispatch({type: 'SAVE.JOURNEY_IDENTITY_DATA.REQUEST', ...params}),
  dispatchFetchJourneyIdentityDocuments: (params) => dispatch({type: 'FETCH.JOURNEY_IDENTITY_DOCUMENTS.REQUEST', ...params}),
  dispatchDeleteJourneyIdentityDocuments: (params) => dispatch({type: 'DELETE.JOURNEY_IDENTITY_DOCUMENTS.REQUEST', ...params}),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(Identity))



// WEBPACK FOOTER //
// ./src/components/interventiondetail/mobility/Identity.js